export default __webpack_public_path__ + "static/media/main-slider-know-action.c8faef93.png";